'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var toConsumableArray = function toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

var is = {
  undef: function undef(v) {
    return v === null || v === undefined;
  },
  notUndef: function notUndef(v) {
    return v !== null && v !== undefined;
  },
  func: function func(f) {
    return typeof f === 'function';
  },
  number: function number(n) {
    return typeof n === 'number';
  },
  string: function string(s) {
    return typeof s === 'string';
  },
  bool: function bool(s) {
    return s === true || s === false;
  },
  array: Array.isArray,
  object: function object(obj) {
    return obj && !is.array(obj) && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
  },
  promise: function promise(p) {
    return p && is.func(p.then);
  }
};

var noop = function noop() {
  return null;
};

var sym = function sym(id) {
  return '@@mangojuice/' + id;
};

function autoInc() {
  var seed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  return function () {
    return ++seed;
  };
}

var nextId = autoInc();

var fastForEach = function fastForEach(subject, iterator) {
  var length = subject.length;

  for (var i = 0; i < length; i++) {
    iterator(subject[i], i, subject);
  }
};

var fastMap = function fastMap(subject, iterator) {
  var length = subject.length;
  var result = new Array(length);

  for (var i = 0; i < length; i++) {
    result[i] = iterator(subject[i], i, subject);
  }

  return result;
};

var ensureError = function ensureError(err) {
  return !(err instanceof Error) ? new Error(err) : err;
};

var fastTry = function fastTry(fn) {
  try {
    return {
      result: fn(),
      error: null
    };
  } catch (err) {
    return {
      result: null,
      error: ensureError(err)
    };
  }
};

var runOnMixed = function runOnMixed(mapper, val, fn) {
  if (is.array(val)) {
    return mapper(val, function (x) {
      return x && fn(x);
    });
  } else if (is.notUndef(val)) {
    var res = fn(val);
    return mapper === fastMap ? [res] : undefined;
  }

  return mapper === fastMap ? [] : undefined;
};

var maybeMap = runOnMixed.bind(null, fastMap);
var maybeForEach = runOnMixed.bind(null, fastForEach);

var deepForEach = function deepForEach(vals, fn) {
  maybeForEach(vals, function deepMapIterator(v) {
    if (is.array(v)) {
      deepForEach(v, fn);
    } else {
      fn(v);
    }
  });
};

function extend(obj, props) {
  if (props) {
    for (var i in props) {
      obj[i] = props[i];
    }
  }

  return obj;
}

var memoize = function memoize(func) {
  var data = void 0;
  var computed = false;

  var momoizer = function momoizer() {
    if (!computed) {
      computed = true;
      data = func.apply(undefined, arguments);
    }

    return data;
  };

  momoizer.computed = function () {
    return computed;
  };

  momoizer.reset = function () {
    data = undefined;
    computed = false;
  };

  return momoizer;
};

function safeExecFunction(logger, func, context) {
  var _fastTry = fastTry(func),
      result = _fastTry.result,
      error = _fastTry.error;

  if (error && logger) {
    logger.onCatchError(error, context);
  }

  return result;
}

var utils = Object.freeze({
  is: is,
  noop: noop,
  sym: sym,
  autoInc: autoInc,
  nextId: nextId,
  fastForEach: fastForEach,
  fastMap: fastMap,
  ensureError: ensureError,
  fastTry: fastTry,
  runOnMixed: runOnMixed,
  maybeMap: maybeMap,
  maybeForEach: maybeForEach,
  deepForEach: deepForEach,
  extend: extend,
  memoize: memoize,
  safeExecFunction: safeExecFunction
}); // Constants

var EMPTY_ARRAY$1 = [];
var EMPTY_OBJECT$1 = {};
/**
 * Class which declares a command that will be executed in the
 * future by some {@link Process#exec}. It contains a function that will be
 * executed, arguments that should be passed to the function
 * and command name.
 *
 * The command also keep a context that should be used to execute
 * a function. Usually this context is some logic instance. You
 * can bind a context to the command using {@link Command#bind} function.
 *
 * The command instance is immutable, so any function that
 * makes some change in the command will produce a new command
 * instead of changing the original one.
 *
 * @class  Command
 * @property {Function} func  An origin function that should be executed
 * @property {Array<any>} args  A set of arguments that should be used
 *                              to execute the fucntion.
 * @param {Function} func
 * @param {Array<any>} args
 * @param {String} name
 */

function Command(func, args, name, options) {
  this.id = func && func.__cmdId || nextId();
  this.func = func;
  this.args = args || EMPTY_ARRAY$1;
  this.options = options || EMPTY_OBJECT$1;
  this.handlable = !this.options.internal;
  this.funcName = this.options.name || name;
  this.name = this.funcName;
}

extend(Command.prototype,
/** @lends Command.prototype */
{
  /**
   * Execute a function stored in the command instance. It passes
   * stored arguments to the function and call it in stored context.
   * Returns the value that was returned form the function.
   * @return {any}
   */
  exec: function exec() {
    var _func;

    return this.func && (_func = this.func).call.apply(_func, [this.logic].concat(toConsumableArray(this.args)));
  },

  /**
   * Clone instance of the command
   * @return {Command}
   */
  clone: function clone() {
    var newCmd = new Command(this.func, this.args, this.funcName, this.options);
    newCmd.id = this.id;
    newCmd.name = this.name;
    newCmd.model = this.model;
    newCmd.logic = this.logic;
    return newCmd;
  },

  /**
   * Check is the command equal to some other command or have
   * a reference to the same origin function. Optionally you can also
   * check that the command binded to some concrete model (using
   * the second argument).
   *
   * You can use many different formats to define the command to check:
   * - Just a string, which should be constructed like
   *   `Logic Class Name + Function Name`
   * - Command object or command factory that you can get from prorotype
   *   of some logic class.
   * - Binded command object or command factory that you can get from
   *   concrete model using {@link logicOf} function
   *
   * @example
   * class ChildLogic {
   *   \@cmd SomeCommand() {}
   * }
   * class MyLogic {
   *   hubAfter(cmd) {
   *     if (cmd.is('ChildLogic.SomeCommand')) {
   *       // by command name
   *     }
   *     if (cmd.is(ChildLogic.prorotype.SomeCommand)) {
   *       // by command factory
   *     }
   *     if (cmd.is(logicOf(this.model.child).SomeCommand)) {
   *       // by binded to a concrete model command factory (commands
   *       // binded for other models will be ignored)
   *     }
   *     if (cmd.is(ChildLogic.prorotype.SomeCommand, this.model.child)) {
   *       // by command factory and concrete child model (commands
   *       // binded for other models will be ignored)
   *     }
   *   }
   * }
   * @param  {Command|string}  cmd   Command object or command factory or command name
   * @param  {?Object}  childModel   Model object that should be binded to the command (optional)
   * @return {Boolean}               Returns `true` if the command have same name, or same origin function
   *                                 and binded to same model (if second argument provided)
   */
  is: function is$$1(cmd, childModel) {
    if (!cmd) return false;
    var func = this.func,
        name = this.name,
        model = this.model;
    var isSameFunc = func === cmd.func || func === cmd || name === cmd;
    var isSameModel = isSameFunc && (childModel && childModel === model || !childModel && cmd.logic && cmd.logic.model === model || !childModel && !cmd.logic);
    return isSameFunc && isSameModel;
  },

  /**
   * Creates a new Command instance (clone the command) and append
   * given list of arguments to the current list of arguments.
   * Returns a new Command with new list of arguments.
   *
   * @param  {Array<any>} args  List of arguments that will be appened
   *                            to tne new Command
   * @return {Command}  New command with appended arguments
   */
  appendArgs: function appendArgs(args) {
    var newCmd = this.clone();
    newCmd.args = [].concat(this.args, args);
    return newCmd;
  },

  /**
   * Creates a new Command instance and set given logic instance in it.
   * Also update command name by name of the origin function and name
   * of the logic class.
   *
   * @param  {LogicBase} logic  A logic instance that should be binded to a command
   * @return {Command} New command binded to given logic instance
   */
  bind: function bind(logic) {
    var newCmd = this.clone();
    if (!logic) return newCmd;
    var ctxName = logic.constructor.name;
    newCmd.name = ctxName ? ctxName + '.' + this.funcName : this.funcName;
    newCmd.model = logic.model;
    newCmd.logic = logic;
    return newCmd;
  }
});
/**
 * Returns a {@link Command} instance or throw an error if given
 * argument can't be used to create a {@link Command} (is not a Command
 * or command factory).
 *
 * @example
 * class MyLogic() {
 *   \@cmd SomeCommand() {
 *     // do something
 *   }
 * }
 *
 * const logic = new MyLogic();
 * ensureCommand(logic.SomeCommand) // returns Command instance
 * // equals to...
 * logic.SomeCommand()
 * @param  {Command|function}  cmd  {@link Command} instance or command factory. When
 *                                  command factory then it will be invoked with
 *                                  no arguments to create a command
 * @return {Command}
 */

function ensureCommand(cmd) {
  if (!cmd) return null;
  if (cmd instanceof Command) return cmd;

  if (is.func(cmd)) {
    if (cmd.func) {
      return cmd();
    } else {
      return new Command(cmd, [], cmd.name);
    }
  }

  throw new Error('You passed something weird instead of cmd');
}
/**
 * Class for declaring an async task. An instance of this object returned
 * from {@link taks} function.
 *
 * A task function is a function that could return a Promise. The resolved value
 * will be passed to a success command handler, the rejected command will be passed
 * to a fail command handler.
 *
 * If task function do not return a Promise, then the returned value passed to a
 * success command, and if the function throw an error then the error passed to
 * a fail command.
 *
 * The task function receive at least one argument – an object with `model`, `shared`
 * and `meta`. All the next arguments will be given from a command that returned a task,
 * if it is not overrided by {@link TaskMeta#args}
 *
 * By default a task is single-threaded. It means that every call to a task will cancel
 * previously running task if it is running. You can make the task to be multi-threaded
 * by {@link TaskMeta#multithread}, so every call to a task won't cancel the running one.
 *
 * In a context of the task function defined special `call` function. This function should
 * be used to invoke sub-tasks. It is important to use `call` to run sub-tasks because
 * `call` create a cancellation point of the task – if the task cancelled, then nothing
 * will be executed after currently running `call` sub-task.
 *
 * `call` returns an object with `result` and `error` fields. If `error` field is not
 * empty, then something weird happened in the sub-task. `call` internally have a try/catch,
 * so it is not necessary to wrap it with try/catch, just check the `error` field in the
 * returned object and if it is not empty – handle it somehow (throw it, or do any custom
 * error handling)
 *
 * Also in a context of the task defined a `notify` function. It is a function that execute
 * notify command if it is defined. The command executed with the same arguments as passed
 * to `notify` function. You can use it to incrementally update a model while the long
 * task is executing, to show some progress for the user.
 *
 * @example
 * async function SubTask(a, b, c) {
 *   this.notify(a + b + c);
 *   await this.call(delay, 100);
 *   return (a / b * c);
 * }
 * async function RootTask({ model }) {
 *   const { result, error } = await this.call(SubTask, 1, 0, 3);
 *   if (error) {
 *     throw new Error('Something weird happened in subtask')
 *   }
 *   return result + 10;
 * }
 * @example
 * class MyLogic {
 *   \@cmd AsyncCommand() {
 *     return task(Tasks.RootTask)
 *       .success(this.SuccessCommand)
 *       .fail(this.FailCommand)
 *       .notify(this.NotifyCommand)
 *   }
 * }
 * @class TaskMeta
 * @param {function} taskFn
 * @param {function} executor
 */


function TaskMeta(taskFn, executor) {
  this.task = taskFn;
  this.executor = executor;
}

extend(TaskMeta.prototype,
/** @lends TaskMeta.prototype */
{
  /**
   * Set a notify handler command. This command executed by call of `this.notify`
   * inside a task with the same arguments as passed to `this.notify`
   * @param  {Command} cmd
   * @return {TaskMeta}
   */
  notify: function notify(cmd) {
    this.notifyCmd = ensureCommand(cmd);
    return this;
  },

  /**
   * Set a success handler command. Will be executed with a value returned
   * from the task, or if the task returned a Promise – with resovled value.
   * @param  {Command} cmd
   * @return {TaskMeta}
   */
  success: function success(cmd) {
    this.successCmd = ensureCommand(cmd);
    return this;
  },

  /**
   * Set a fail handler command. Will be executed with error throwed in the task,
   * or if the task returned a Promise – with rejected value.
   * @param  {Command} cmd
   * @return {TaskMeta}
   */
  fail: function fail(cmd) {
    this.failCmd = ensureCommand(cmd);
    return this;
  },

  /**
   * Define the task to be "multi-thread", so every call
   * will run in parallel with other calls of the same task
   * in scope of one process (model).
   * @param  {boolean} val
   * @return {TaskMeta}
   */
  multithread: function multithread(val) {
    this.execEvery = is.undef(val) ? true : val;
    return this;
  },

  /**
   * Set task executor function. The executor function should return an object
   * that should have at least two fields: `exec` and `cancel` functions.
   * `exec` should return a promise which should be resolved or rejected
   * with an object `{ result, error }`. A `cancel` function should stop
   * the task execution.
   *
   * @param  {Function} engine  A function that returns
   *                            `{ exec: Function, cancel: Function }` object
   * @return {TaskMeta}
   */
  engine: function engine(_engine) {
    this.executor = _engine;
    return this;
  },

  /**
   * Override arguments which will be passed to the task
   * starting from second argument. By default a task will receive
   * the same set of arguments as a task command. If this function invoked,
   * then the task will receive given arguments instead of command arguments.
   * @param  {...any} args
   * @return {TaskMeta}
   */
  args: function args() {
    for (var _len = arguments.length, _args = Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    this.customArgs = _args;
    return this;
  }
});
var ZERO_DELAY = false;
/**
 * Set all delays in the mangojuice to zero. It means, that:
 * - any `delay(...)` will be resolved right at the end of call stack
 * - eny cmd debounce/throttle will be executed right at the end of a call stack
 *
 * @private
 * @param  {bool} val
 */

var setZeroDelay = function setZeroDelay(val) {
  return ZERO_DELAY = !!val;
};

var config = Object.freeze({
  get ZERO_DELAY() {
    return ZERO_DELAY;
  },

  setZeroDelay: setZeroDelay
});
/**
 * An async task executor which aimed only to help with
 * delayed (throttle/debounce) command execution.
 * Supports to run in "debounce" and "throttle" mode,
 * with instant init call or without.
 *
 * @private
 */

function ThrottleTask(executor, cleanup, options) {
  this.finish = noop;
  this.executor = executor || noop;
  this.cleanup = cleanup || noop;
  this.delay = ZERO_DELAY ? 0 : options.throttle || options.debounce || 0;
  this.debounce = options.debounce > 0;
  this.noInitCall = !!options.noInitCall;
  this.doExec = this.doExec.bind(this);
}

extend(ThrottleTask.prototype, {
  exec: function exec(cmd) {
    if (this.isThrottled) {
      this.lastCmd = cmd;
      this.ensureExecution();
      if (this.debounce) this.restart();
      return;
    }

    this.isThrottled = true;
    this.restart();

    if (this.noInitCall && !this.calledOnce) {
      this.lastCmd = cmd;
      this.ensureExecution();
    } else {
      this.executor(cmd);
      this.finalize();
    }
  },
  doExec: function doExec() {
    this.isThrottled = false;

    if (this.lastCmd) {
      this.calledOnce = true;
      var finalCmd = this.lastCmd;
      this.lastCmd = null;
      this.exec(finalCmd);
    } else {
      this.cleanup();
      this.finalize();
    }
  },
  ensureExecution: function ensureExecution() {
    var _this = this;

    if (!this.execution) {
      this.execution = new Promise(function (r) {
        return _this.finish = r;
      });
    }
  },
  finalize: function finalize() {
    this.finish();
    this.execution = null;
    this.finish = noop;
  },
  cancel: function cancel() {
    clearInterval(this.timer);
    this.finalize();
    this.cleanup();
  },
  restart: function restart() {
    clearInterval(this.timer);
    this.timer = setTimeout(this.doExec, this.delay);
  }
});
/**
 * A class which defins a logger for tracking command execution process.
 * The default implmenetation just defines all possible logger
 * methods (log points) and print errors to the console.
 * Extend this class to define your own logging functionality
 * (like logging errors with Setnry or Loggly)
 *
 * @class  DefaultLogger
 * @example
 * // ./index.js
 * import { DefaultLogger, run } from 'mangojuice-core';
 * import MainBlock from './blocks/MainBlock';
 *
 * // Implement custom logger
 * class SetnryLogger extends DefaultLogger {
 *   onCatchError(error, cmd) {
 *     Raven.catchException(error);
 *   }
 * }
 *
 * // Pass instance of the Logger to `run` options object.
 * run(MainBlock, { logger: new SetnryLogger() });
 */

function DefaultLogger() {}

extend(DefaultLogger.prototype,
/** @lends DefaultLogger.prototype */
{
  /**
   * This method invoked right before anything else - as the first thing
   * in {@link Process#exec}. Even before any {@link LogicBase#hubBefore}.
   * @param  {Command} cmd  Command that just started execution process
   */
  onStartExec: function onStartExec(cmd) {},

  /**
   * Invoked right before command will go through all {@link LogicBase#hubBefore} or {@link LogicBase#hubAfter}
   * up in the blocks tree. The second argument indicates is it called for {@link LogicBase#hubBefore}
   * or for {@link LogicBase#hubAfter}.
   * @param  {Command}  cmd    Command that is going to go through hubs in parent blocks
   * @param  {Boolean} isAfter If true then the command is going through "after" hubs, "before" otherwise
   */
  onStartHandling: function onStartHandling(cmd, isAfter) {},

  /**
   * Invoked when the command went through all hubs and when all sync commands
   * returned from hubs was executed.
   * @param  {Command}  cmd     Command that went through all hubs
   * @param  {Boolean} isAfter  If true then the command going through "after" hubs, "before" otherwise
   */
  onEndHandling: function onEndHandling(cmd, isAfter) {},

  /**
   * Invoked when the command function executed and the return of the function processed –
   * all returned commands executed, all async tasks started, the model updated.
   * But it invoked before the command go through "after" hubs.
   * @param  {Command} cmd  Command that was exectued and the return processed
   * @param  {any} result   Returned object from the command's function
   */
  onExecuted: function onExecuted(cmd, result) {},

  /**
   * Invoked right after the command go throught "after" hubs. It is the final
   * stage of command execution.
   * @param  {Command} cmd  Command that was fully executed and handled by parent blocks
   */
  onEndExec: function onEndExec(cmd) {},

  /**
   * Invoked if any uncaught error happened while execution of the command
   * or anywhere else in the logic, like in {@link LogicBase#port} or in {@link LogicBase#computed}.
   * By default print the error using `console.error`.
   * @param  {Error} error  The error instance
   * @param  {?Command} cmd   Command that was executing while the error happened
   */
  onCatchError: function onCatchError(error, cmd) {
    console.error(error);
  }
});
/**
 * Get a {@link Process} instance attached to the given model object.
 * Internally it get a `__proc` field from the given model and returns it.
 *
 * If given model do not have attached Process, then an Error will be throwed,
 * but only if the second argument is not true, which ignores the error.
 *
 * @param  {Object} model  A model with attached {@link Process}
 * @param {bool} ignoreError  If true then no error will be throwed if Process
 *                            is not attached to the model
 * @return {Process}  An instance of {@link Process} attached to the model
 */

function procOf(model, ignoreError) {
  var proc = model && model.__proc;

  if (!proc && !ignoreError) {
    throw new Error('Process is not defined in the model');
  }

  return proc;
}
/**
 * Creates a command object with given name and automatically
 * binded logic instance.
 *
 * @private
 * @param  {string}   name
 * @param  {object}   logic
 * @param  {bool}     nonhandlable
 * @param  {function} func
 * @param  {object}   options
 * @return {function}
 */


function createCommandFactory(func, logic, name, options) {
  var id = func.__cmdId || nextId();

  var creator = function commandFactory() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var cmd = new Command(func, args, name, options);
    return logic ? cmd.bind(logic) : cmd;
  };

  func.__cmdId = id;
  creator.id = id;
  creator.func = func;
  creator.logic = logic;
  return creator;
}
/**
 * Creates a object field descriptor with given options and
 * all data passed to class method decorator – prototype, method name,
 * etc.
 *
 * @private
 * @param  {object} options
 * @param  {object} obj
 * @param  {string} methodName
 * @param  {object} descr
 * @param  {bool}   nonhandlable
 * @param  {string} cmdName
 * @return {object}
 */


function createCommandDescriptor(options, obj, methodName, descr) {
  // Creates a descriptor with lazy factory creation and autobinding
  // to the instance of the logic, but only when some model exists
  // and command executed in scope of top-level prototype in prototypes
  // chain (to support calling "super" commands in extended logic)
  return {
    configurable: true,
    enumerable: true,
    get: function get() {
      var haveModel = this && !!this.model && !!this.meta;
      var fromInstance = Object.getPrototypeOf(this) === obj;
      var factory = createCommandFactory(descr.value, haveModel ? this : null, methodName, options);

      if (haveModel && fromInstance) {
        Object.defineProperty(this, methodName, {
          configurable: false,
          enumerable: true,
          value: factory
        });
      }

      return factory;
    }
  };
}
/**
 * Decorator that converts a logic method to a command factory.
 * The result function (command factory function) is a function
 * that return a {@link Command} instnace with the decorated function
 * and arguments that you will pass to a command factory function.
 *
 * You can use this decorator without arguments or with an options
 * argument (object)
 *
 * Check {@link Process#exec} to see what the origin function
 * could return to do something. If in short, it can return:
 * nothing, command (or factory or array of commands), task,
 * model update object.
 *
 * @example
 * class RegularLogic {
 *   \@cmd RegularCommand() {
 *     // do something
 *   }
 * }
 * @example
 * class RegularLogic {
 *   \@cmd({ debounce: 300 })
 *   DebouncedCommand() {
 *     // if you will call this command 3 times every
 *     // 100ms then it will be executed 2 times,
 *     // first right when you call it for a first time,
 *     // and second in 600ms.
 *   }
 * }
 * @example
 * class RegularLogic {
 *   \@cmd({ throttle: 300 })
 *   ThrottledCommand() {
 *     // if you will call this command 3 times every
 *     // 100ms then it will be executed 2 times,
 *     // first right when you call it for a first time,
 *     // and second in 300ms.
 *   }
 * }
 * @example
 * class RegularLogic {
 *   \@cmd({ throttle: 300, noInitCall: true })
 *   ThrottledCommand() {
 *     // if you will call this command 3 times every
 *     // 100ms then it will be executed 1 time in 300ms.
 *   }
 * }
 * @example
 * class RegularLogic {
 *   \@cmd({ internal: true })
 *   _InternalCommand() {
 *     // this command can't be caught in `hubBefore` or `hubAfter`
 *     // in parent logics. Use it carefully.
 *   }
 * }
 * @param  {Object} obj           If only this argument passed then it will be considered
 *                                as options object which can customize command behaviour.
 * @param  {number} obj.debounce  If greeter than zero then an exeuction
 *                                of the command will be debounced by given amount of
 *                                milliseconds
 * @param  {number} obj.throttle  If greeter than zero then an exeuction
 *                                of the command will be throttled by given amount of
 *                                milliseconds
 * @param  {bool} obj.noInitCall  If true then debounced/throttled execution
 *                                won't start with init command call. By default
 *                                debounced/throttled command will be instantly
 *                                exected and only then wait for a chance to execute
 *                                again. With `noInitCall=true` there is no instant init
 *                                command call.
 * @param  {bool} obj.internal    Make the command invisible for parent {@link LogicBase#hubBefore}
 *                                and {@link LogicBase#hubAfter}. Use it for commands that shouldn't
 *                                be handled by hubs to increse performance.
 * @param {string} obj.name       By default name of the command taken from origin function. With this
 *                                option you can override the name with any other value.
 * @return {Function|object}      Command factory function (if all three arguemnts passed)
 *                                or a decorator function with binded options object
 *                                (that you pass as a first argument)
 */


function cmd(obj, methodName, descr) {
  if (is.undef(methodName)) {
    return createCommandDescriptor.bind(null, obj);
  }

  return createCommandDescriptor(null, obj, methodName, descr);
} // Internals


var observersToNotify = {};
var execCounter = 0;
/**
 * Queue run of model observer. The observer
 * will be executed ASAP afther the end of the stack.
 * @private
 * @param  {Process} proc
 * @return {Promise}
 */

function enqueueNotifyObserver(observer) {
  observersToNotify[observer.id] = observer;
}
/**
 * Go through all queued observers and run them. Empty
 * the queue before that.
 * @private
 * @return {Promise}
 */


function notifyQueuedObservers() {
  var list = observersToNotify;
  var obsIds = Object.keys(list);
  observersToNotify = {};
  fastForEach(obsIds, function queuedObserversIterator(obsId) {
    list[obsId]();
  });
}
/**
 * Increase processing counter
 * @private
 */


function incExecCounter() {
  execCounter += 1;
}
/**
 * Decrease processing counter. When hits zero – run all
 * pending observers
 * @private
 */


function decExecCounter() {
  execCounter -= 1;

  if (execCounter <= 0) {
    execCounter = 0;
    notifyQueuedObservers();
  }
}
/**
 * A function that adds a handler to the {@link Process} instance attached
 * to a given model, that will be invoked on every command that changed
 * the model. Useful for tracking changes to re-render a view of the model.
 *
 * @example
 * import { run, cmd, observe, logicOf } from 'mangojuice-core';
 *
 * class MyLogic {
 *   \@cmd MultipleUpdates() {
 *     return [
 *       this.UpdateOne,
 *       this.UpdateTwo
 *     ];
 *   }
 *   \@cmd UpdateOne() {
 *     return { one: this.model.one + 1 };
 *   }
 *   \@cmd UpdateTwo() {
 *     return { two: this.model.two + 1 };
 *   }
 * }
 *
 * const res = run({
 *   Logic: MyLogic,
 *   createModel: () => ({ one: 1, two: 1 })
 * });
 *
 * observe(res.model, () => console.log('not-batched'));
 * observe(res.model, () => console.log('batched'), { batched: true });
 *
 * res.proc.exec(logicOf(res.model).MultipleUpdates);
 *
 * // `not-batched` will be printed two times
 * // `batched` will be printed only once
 * @param  {Object} model      A model with attached {@link Process} instance
 * @param  {Function} handler  A function that will be invoked after every command
 *                             that changed the model.
 * @param  {?Object} options   An object with options
 * @param  {bool} options.batched  If true then the handler will be invoked only when
 *                                 the commands stack is empty and model was changed during
 *                                 the stack execution. Useful to reduce amount of not necessary
 *                                 view re-renderings.
 * @return {Function}
 */


function observe(model, handler, options) {
  var modelProc = procOf(model);
  var type = options && options.type || 'observers';
  if (!modelProc[type]) return; // Wrap original handler to execute with error logger

  var finalHandler = function finalHandler(arg) {
    return safeExecFunction(modelProc.logger, function () {
      return handler(arg);
    });
  }; // Wrap again to execute at the end of the commands stack


  if (options && options.batched) {
    var originalHandler = finalHandler;
    originalHandler.id = nextId();

    finalHandler = function batchedObserver() {
      enqueueNotifyObserver(originalHandler);
    };
  }

  modelProc[type].push(finalHandler);
  return function removeObserver() {
    if (modelProc[type]) {
      modelProc[type] = modelProc[type].filter(function (x) {
        return x !== finalHandler;
      });
    }
  };
}
/**
 * A symbol for setting custom promise cancel function.
 * You can use it to specify some specific logic that
 * should be executed when some task canceled. Like for
 * `delay` function you can clear a timer
 * (see `delay` sources below).
 * @private
 * @type {string}
 */


var CANCEL = sym('CANCEL_PROMISE');
/**
 * Main task executor class, which set as a context for a
 * task function. Provides a way to execute a task, cancel
 * the task and wait for all subtasks to be finished.
 *
 * @private
 * @class AsyncTask
 * @param {Object|AsyncTask}   parent
 * @param {Function}          fn
 * @param {Array<any>}        args
 */

function AsyncTask(parent, fn, args) {
  var _this = this;

  this.execution = null;
  this.parent = parent;
  this.subtasks = [];
  this.cancelResolve = noop;
  this.cancelPromise = new Promise(function (r) {
    return _this.cancelResolve = r;
  });
  this.args = args;
  this.fn = fn;
  this.done = false;
  this.cancelled = false;

  if (parent && parent.cancelPromise) {
    parent.cancelPromise.then(this.cancelResolve);
  }
}

extend(AsyncTask.prototype,
/** @lends AsyncTask.prototype */
{
  /**
   * Execute a task and handle the response. Returns
   * an array which will be executed when the task and all
   * subtasks finished
   * @return {Promise}
   */
  exec: function exec() {
    var _this2 = this;

    if (this.execution) {
      return this.execution;
    }

    var task = fastTry(function () {
      return _this2.fn.apply(_this2, _this2.args);
    });

    if (task.error) {
      this.execution = Promise.resolve(task);
      return this.execution;
    }

    var handleTaskFailed = function handleTaskFailed(err) {
      return handleTaskFinish(null, err);
    };

    var handleTaskFinish = function handleTaskFinish(result, error) {
      if (_this2.done || _this2.cancelled) return;

      if (error) {
        _this2.cancel();

        return {
          result: null,
          error: error
        };
      }

      if (result instanceof Error && result.cancelled) {
        _this2.cancelled = true;

        var runCancelHandlers = function runCancelHandlers() {
          if (task.result && task.result[CANCEL]) task.result[CANCEL]();
          if (_this2.cancelHandler) _this2.cancelHandler();
        };

        var _fastTry = fastTry(runCancelHandlers),
            cancelError = _fastTry.error;

        var ret = {
          result: null,
          error: cancelError || result
        };
        return result.task === _this2 ? ret : Promise.reject(ret);
      }

      if (_this2.subtasks.length > 0) {
        var resProxy = function resProxy() {
          return result;
        };

        var subtasksWaitPromise = Promise.all(_this2.subtasks).then(resProxy, resProxy);
        var finalRace = Promise.race([_this2.cancelPromise, subtasksWaitPromise]).then(handleTaskFinish, handleTaskFailed);
        _this2.subtasks = [];
        return finalRace;
      }

      _this2.done = true;
      return {
        result: result,
        error: null
      };
    };

    this.execution = Promise.race([this.cancelPromise, task.result]).then(handleTaskFinish, handleTaskFailed);
    return this.execution;
  },

  /**
   * Call some subtask. The parrent task will be finished only
   * when all children tasks will be resolved
   * @param  {Function}  fn
   * @param  {...any} args
   * @return {Promise}
   */
  call: function call(fn) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var task = new AsyncTask(this, fn, args);
    var execPromise = task.exec();
    this.subtasks.push(execPromise);
    execPromise.task = task;
    return execPromise;
  },

  /**
   * Cancel this task and all children subtasks
   */
  cancel: function cancel() {
    var err = new Error('Cancelled');
    err.cancelled = true;
    err.task = this;
    this.cancelResolve(err);
  },

  /**
   * Set a handler which will be executed when task cancelled
   * @param  {Function} handler
   */
  onCancel: function onCancel(handler) {
    this.cancelHandler = handler;
  },

  /**
   * Run `notify` function of parent object/task with provided
   * arguments if defined.
   * @param  {...any} args
   */
  notify: function notify() {
    if (this.parent && this.parent.notify) {
      var _parent;

      return (_parent = this.parent).notify.apply(_parent, arguments);
    }
  }
});
/**
 * A helper function for delaying execution. Returns a Promise
 * which will be resolved in given amount of milliseconds. You can
 * use it in {@link task} to implement some delay in execution, for
 * debouncing for example.
 *
 * @param  {number}  ms  An amount of milliseconds to wait
 * @return {Promise} A promise that resolved after given amount of milliseconds
 */

function delay(ms) {
  var actualMs = ZERO_DELAY ? 0 : ms;
  var timeoutId = void 0;
  var res = new Promise(function (resolve) {
    timeoutId = setTimeout(function () {
      return resolve();
    }, actualMs);
  });

  res[CANCEL] = function () {
    return clearTimeout(timeoutId);
  };

  return res;
}
/**
 * Cancel task with given id in the process if exists
 * and can be cancelled (have `cancel` function defined)
 *
 * @private
 * @param  {Process} proc
 * @param  {nubmer} id
 */


function cancelTask(proc, taskId) {
  var taskProcs = proc.tasks[taskId];
  delete proc.tasks[taskId];

  for (var execId in taskProcs) {
    var taskCall = taskProcs[execId];

    if (taskCall && taskCall.cancel) {
      taskCall.cancel();
    }
  }
}
/**
 * Cancel all executing tasks of the process
 *
 * @private
 * @param  {Process} proc
 */


function cancelAllTasks(proc) {
  for (var taskId in proc.tasks) {
    cancelTask(proc, taskId);
  }
}
/**
 * This function should be used to cancel async {@link task} execution.
 * Also it can cancel the debounced/throttled command.
 * - In case with task, if task was executing while you call a cancel command,
 *   the task will be cancelled (execution stopped). Otherwise nothing will happen.
 * - In case with debounced/throttled command, if the command scheduled to be executed
 *   then the schedule timer will be cleared and the command won't be executed.
 *   If the command is not scheduled then nothing happens.
 *
 * To use it just pass a command or command factory as a first argument
 * and return it from some other command.
 *
 * @example
 * class SomeLogic {
 *   \@cmd CancelSomethingCommand() {
 *     return [
 *       cancel(this.TaskCommand),
 *       cancel(this.DebounceCommand)
 *     ];
 *   }
 *   \@cmd TaskCommand() {
 *     return task(Tasks.SomeTask);
 *   }
 *   \@cmd({ debounce: 300 })
 *   DebounceCommand() {
 *     // do something
 *   }
 * }
 * @param  {Command|function} cmd  Command or command factory that you wan to cancel. Could
 *                                 be a command that returns {@link task} or debounced/throttled
 *                                 command
 * @return {Command} Returns a new command that will cancel the execution of the command
 *                   passed as an argument.
 */


function cancel(cmd) {
  var realCmd = ensureCommand(cmd);

  var cancelFn = function cancelFn() {
    var proc = procOf(this.model);
    cancelTask(proc, realCmd.id);
  };

  var cmdName = realCmd.funcName + '.Cancel';
  var cancelCmd = new Command(cancelFn, null, cmdName, {
    internal: true
  });
  return cancelCmd.bind(realCmd.logic);
} // Constants


var EMPTY_ARRAY = [];
var EMPTY_OBJECT = {};
var EMPTY_FINISHED = Promise.resolve();
var DELAY_TASK = 'DELAY';
/**
 * Go from current proc to the root of the proc tree
 * and run iterator function if handler of given type
 * exists in the process instance.
 *
 * @private
 * @param  {Process} proc
 * @param  {string} type
 * @param  {function} iterator
 */

function mapParents(proc, iterator) {
  var currParent = proc.parent;
  var res = [];

  while (currParent) {
    res.push(iterator(currParent));
    currParent = currParent.parent;
  }

  return res;
}
/**
 * Run `children` and `config` methods of the logic object
 * and create `config` object in the Process based on the result.
 * @private
 */


function prepareConfig(proc) {
  var logicClass = proc.logicClass,
      configArgs = proc.configArgs,
      logger = proc.logger;
  var config = {
    children: EMPTY_OBJECT,
    childrenKeys: EMPTY_ARRAY,
    meta: {}
  };
  var logic = new logicClass();
  proc.logic = logic;

  var safeExecConfig = function safeExecConfig() {
    return logic.config && logic.config.apply(logic, toConsumableArray(configArgs));
  };

  var configRes = safeExecFunction(logger, safeExecConfig);
  config = configRes || config;
  config.meta = config.meta || {};
  logic.meta = config.meta;
  proc.config = config;
}
/**
 * Create process and bind the process to child model
 * with given name. If model field is empty then do nothing.
 * If model already binded to some model do nothing.
 * Return true if model sucessfully binded to the process.
 * Othersise returns false
 *
 * @private
 * @param  {Object} childModel
 * @param  {String} fieldName
 * @return {Boolean}
 */


function bindChild(proc, childModel, fieldName) {
  if (childModel && !procOf(childModel, true)) {
    var childDef = proc.config.children[fieldName];
    var logic = is.func(childDef) ? childDef : childDef.logic;
    var configArgs = is.func(childDef) ? EMPTY_ARRAY : childDef.args;
    var subProc = new proc.constructor({
      logic: logic,
      configArgs: configArgs,
      parent: proc,
      context: proc.context,
      sharedModel: proc.sharedModel,
      logger: proc.logger
    });
    subProc.bind(childModel);
    return true;
  }

  return false;
}
/**
 * Go throught all children fields and bind each child
 * model to appropreate logic
 *
 * @private
 * @param  {Process} proc
 */


function bindChildren(proc) {
  var logic = proc.logic,
      logger = proc.logger,
      config = proc.config,
      configArgs = proc.configArgs;

  if (logic.children) {
    var safeExecChildren = function safeExecChildren() {
      return logic.children.apply(logic, toConsumableArray(configArgs));
    };

    config.children = safeExecFunction(logger, safeExecChildren) || {};
    config.childrenKeys = Object.keys(config.children);
  }

  var iterateChildren = function iterateChildren(model, field) {
    return bindChild(proc, model, field);
  };

  forEachChildren(proc, proc.model, iterateChildren);
}
/**
 * Stop all running observers for all existing computed fields
 *
 * @private
 * @param  {Process} proc
 */


function stopComputedObservers(proc) {
  var computedFields = proc.computedFields;
  maybeForEach(computedFields, function (f) {
    maybeForEach(f.observers, function (o) {
      return o();
    });
  });
}
/**
 * Replace fields in the model with computed getter with memoization
 * if defined in `logic.computed`.
 * Provide a way to define computed field with object block models
 * dependencies. So the field will be invalidated and re-computed
 * when one of dependent models will be changed.
 * @private
 */


function bindComputed(proc) {
  if (proc.destroyed) return;
  var logic = proc.logic,
      logger = proc.logger;
  var computedFields = EMPTY_ARRAY;
  stopComputedObservers(proc);

  if (logic.computed) {
    var safeExecComputed = function safeExecComputed() {
      return logic.computed();
    };

    var ownComputedFields = safeExecFunction(logger, safeExecComputed);

    if (ownComputedFields) {
      var fieldBinder = function fieldBinder(k) {
        return bindComputedField(proc, k, ownComputedFields[k]);
      };

      computedFields = maybeMap(Object.keys(ownComputedFields), fieldBinder);
    }
  }

  proc.computedFields = computedFields;
}
/**
 * Bind field in the model with given computed function or dependency
 * object.
 *
 * @private
 * @param  {Process} proc
 * @param  {string} fieldName
 * @param  {function|ComputedField} computeVal
 * @return {Memoize}
 */


function bindComputedField(proc, fieldName, computeVal) {
  var logger = proc.logger;
  var get$$1 = noop;

  if (is.func(computeVal)) {
    get$$1 = memoize(function () {
      return safeExecFunction(logger, computeVal);
    });
  } else if (is.object(computeVal)) {
    var computeWithDeps = function computeWithDeps() {
      return computeVal.computeFn.apply(computeVal, toConsumableArray(computeVal.deps));
    };

    get$$1 = memoize(function () {
      return safeExecFunction(logger, computeWithDeps);
    });

    var updateHandler = function updateHandler() {
      if (get$$1.computed()) {
        get$$1.reset();
        runAllObservers(proc);
      }
    };

    var observeDependency = function observeDependency(m) {
      return observe(m, updateHandler);
    };

    get$$1.observers = maybeMap(computeVal.deps, observeDependency);
  }

  Object.defineProperty(proc.model, fieldName, {
    enumerable: true,
    configurable: true,
    set: noop,
    get: get$$1
  });
  return get$$1;
}
/**
 * Associate instance of the Process with given model by setting
 * hidden `__proc` field in the model. Also set model and shared model,
 *
 * @private
 * @param  {Process} proc
 * @param  {Object} model
 */


function bindModel(proc, model) {
  var logic = proc.logic,
      sharedModel = proc.sharedModel;
  proc.model = model;
  logic.model = model;
  logic.shared = sharedModel;
  Object.defineProperty(model, '__proc', {
    value: proc,
    enumerable: false,
    configurable: true
  });
}
/**
 * Itereate through all children models with logic assigned
 * and run binded process. Returns a Promise which will be
 * resolved when all inicialisation of all children logics
 * will be finished.
 *
 * @private
 * @param  {Process} proc
 * @return {Promise}
 */


function runChildren(proc) {
  var childRunner = function childRunner(childModel) {
    return procOf(childModel).run();
  };

  forEachChildren(proc, proc.model, childRunner);
}
/**
 * Execute `port` method of the logic, if provided. Returns a Promise
 * which will be resolved when returend by `port` promise will be resolved.
 * If `port` returns not a Promise then it will be resolved instantly.
 *
 * @private
 * @param  {Process} proc
 * @return {Promise}
 */


function runPorts(proc) {
  var logic = proc.logic,
      logger = proc.logger,
      destroyPromise = proc.destroyPromise,
      exec = proc.exec;

  if (logic.port) {
    logic.port(exec, destroyPromise);
  }
}
/**
 * Execute init commands which could be defined in `config` method
 * of the object. Returns a Promise which will be resolved when
 * all init commands will be fully executed.
 *
 * @private
 * @param  {Process} proc
 * @return {Promise}
 */


function runInitCommands(proc) {
  var initCommands = proc.config.initCommands,
      exec = proc.exec;

  if (initCommands) {
    var initCmdIterator = function initCmdIterator(cmd$$1) {
      return exec(cmd$$1);
    };

    maybeForEach(initCommands, initCmdIterator);
  }
}
/**
 * Ren all model observers and returns a Promise which will
 * be resolved when all handlers executed and returned promises
 * is also resolved
 *
 * @private
 * @param  {Process} proc
 * @return {Promise}
 */


function runAllObservers(proc) {
  var observersIterator = function observersIterator(obs) {
    return obs();
  };

  maybeForEach(proc.observers, observersIterator);
}
/**
 * Resolve destroy promise which will notify `port` that it should
 * cleanup and stop execution.
 *
 * @private
 * @param  {Process} proc
 */


function stopPorts(proc) {
  if (proc.destroyResolve) {
    proc.destroyResolve();
    proc.destroyResolve = null;
    proc.destroyPromise = null;
  }
}
/**
 * Map children model fields which have associated
 * logic in `children` function of the logic using given
 * iterator function.
 * Returns a Promise which resolves with a list with data
 * returned by each call to iterator function.
 *
 * @private
 * @param  {Process} proc
 * @param  {Object} model
 * @param  {Function} iterator
 * @param  {Array} iterKeys
 * @return {Promise}
 */


function forEachChildren(proc, model, iterator, iterKeys) {
  var config = proc.config;
  if (!iterator || !config.children) return;
  var childrenKeys = iterKeys || config.childrenKeys || EMPTY_ARRAY;

  var childRunner = function childRunner(childModel, k) {
    return iterator(childModel, k);
  };

  var keyIterator = function keyIterator(k) {
    if (config.children[k]) {
      maybeForEach(model[k], function (x) {
        return childRunner(x, k);
      });
    }
  };

  maybeForEach(childrenKeys, keyIterator);
}
/**
 * Execute given task object in scope of given Process.
 * Returns a Promise which will be resolved when task will
 * be resolved or reject with with a command, which should
 * be executed next.
 *
 * @private
 * @param  {Process} proc
 * @param  {Task} taskObj
 * @return {Promise}
 */


function execTask(proc, taskObj, cmd$$1) {
  var execId = nextId();
  var taskId = cmd$$1.id;
  var tasks = proc.tasks,
      logger = proc.logger,
      model = proc.model,
      sharedModel = proc.sharedModel,
      config = proc.config;
  var task = taskObj.task,
      executor = taskObj.executor,
      notifyCmd = taskObj.notifyCmd,
      successCmd = taskObj.successCmd,
      failCmd = taskObj.failCmd,
      customArgs = taskObj.customArgs,
      execEvery = taskObj.execEvery; // If not in multi-thread mode – cancel all running task with
  // same identifier (command id)

  if (!execEvery) {
    cancelTask(proc, taskId);
  } // Handle result of the execution of a task – returns
  // success command if error not defined, fail command otherwise


  var handleResult = function handleResult(_ref) {
    var result = _ref.result,
        error = _ref.error;

    if (tasks[taskId]) {
      delete tasks[taskId][execId];
    }

    if (error) {
      if (error.cancelled) {
        return new Command(null, null, cmd$$1.funcName + '.Cancelled', {
          internal: true
        });
      } else {
        var actualFailCmd = failCmd && failCmd.appendArgs([error]);
        if (!actualFailCmd) logger.onCatchError(error);
        return actualFailCmd;
      }
    } else {
      var actualSuccessCmd = successCmd && successCmd.appendArgs([result]);
      return actualSuccessCmd;
    }
  }; // Run notify command if presented


  var handleNotify = function handleNotify() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (notifyCmd) {
      proc.exec(notifyCmd.appendArgs(args));
    }
  }; // Run the task function and wait for the result


  var props = {
    model: model,
    meta: config.meta,
    shared: sharedModel
  };
  var context = {
    notify: handleNotify
  };
  var args = customArgs || cmd$$1.args || EMPTY_ARRAY;
  var taskCall = executor.call.apply(executor, [context, task, props].concat(toConsumableArray(args))); // Track task execution

  tasks[taskId] = tasks[taskId] || {};
  tasks[taskId][execId] = taskCall;
  return taskCall.exec().then(handleResult, handleResult);
}
/**
 * Update the binded model with update object passed as an argument.
 * Returns true when model was changed, otherwise returns false.
 * Also while updating process destryoy/create processes for
 * removed/added models.
 *
 * @private
 * @param  {?Object} updateObj
 * @return {Boolean}
 */


function updateModel(proc, updateObj) {
  if (!updateObj) return false;
  var tick = nextId();
  var updateKeys = Object.keys(updateObj);
  var model = proc.model;
  var rebindComputed = false;

  var updateMarker = function updateMarker(childModel, fieldName) {
    if (bindChild(proc, childModel, fieldName)) {
      rebindComputed = true;
      procOf(childModel).run();
    }

    procOf(childModel).tick = tick;
  };

  var unmarkedDestroyer = function unmarkedDestroyer(childModel) {
    var childProc = procOf(childModel);

    if (childProc.tick !== tick) {
      rebindComputed = true;
      childProc.destroy();
    }
  }; // Go throught all children models and mark which one
  // created and removed


  forEachChildren(proc, updateObj, updateMarker);
  forEachChildren(proc, model, unmarkedDestroyer, updateKeys);
  extend(model, updateObj); // Computed field may depend on child model, and when child
  // model destroyed/created we should reflect it in computed fields
  // Otherwise just reset all computed fields

  if (rebindComputed) {
    bindComputed(proc);
  } else {
    maybeForEach(proc.computedFields, function (f) {
      return f.reset();
    });
  }

  return true;
}
/**
 * Run all parent handler from parent processes to handle
 * executed command. Returns a promise which will be resolved
 * when all handlers will be fully executed.
 *
 * @private
 * @param  {Object} model
 * @param  {Object} cmd
 * @return {Promise}
 */


function handleCommand(proc, cmd$$1, isAfter) {
  if (!cmd$$1.handlable) return;
  var logger = proc.logger;
  var logicFnName = isAfter ? 'hubAfter' : 'hubBefore';
  var handlersArr = isAfter ? proc.handlersAfter : proc.handlersBefore;
  logger.onStartHandling(cmd$$1, isAfter); // Get all commands from all defined hubs

  var cmds = mapParents(proc, function maybeExecHub(parnetProc) {
    if (parnetProc.logic[logicFnName]) {
      var safeExecHub = function safeExecHub() {
        return parnetProc.logic[logicFnName](cmd$$1);
      };

      return safeExecFunction(logger, safeExecHub);
    }
  }); // Exec all commands in defined order

  deepForEach(cmds, function (c) {
    return proc.exec(c);
  });
  maybeForEach(handlersArr, function (handler) {
    return handler(cmd$$1);
  });
  logger.onEndHandling(cmd$$1, isAfter);
}
/**
 * Actually execute the command. It iis running "before" handler,
 * then command itself, then "after" handlers and then emit
 * "update" event on the process if model was updated.
 * Returns a promise which will be resolved when a command
 * will be fully executed (command + all handlers).
 *
 * @private
 * @param  {Object} cmd
 */


function doExecCmd(proc, rawCmd) {
  var logger = proc.logger,
      exec = proc.exec;
  var cmd$$1 = !rawCmd.logic ? rawCmd.bind(proc.logic) : rawCmd;
  var modelUpdated = false; // Prepare and run before handlers

  incExecCounter();
  logger.onStartExec(cmd$$1);
  handleCommand(proc, cmd$$1, false); // Execute command

  var safeExecCmd = function safeExecCmd() {
    return cmd$$1.exec();
  };

  var result = safeExecFunction(logger, safeExecCmd, cmd$$1);

  if (result) {
    if (result instanceof TaskMeta) {
      var taskPromise = execTask(proc, result, cmd$$1);
      taskPromise.then(exec, exec);
    } else if (result && (is.array(result) || result.func && result.id)) {
      deepForEach(result, function (x) {
        return exec(x);
      });
    } else if (is.object(result)) {
      modelUpdated = updateModel(proc, result);
    }
  } // Emit model update for view re-rendering


  if (modelUpdated) {
    runAllObservers(proc);
  } // Run after handlers


  logger.onExecuted(cmd$$1, result);
  handleCommand(proc, cmd$$1, true);
  logger.onEndExec(cmd$$1);
  decExecCounter();
}
/**
 * Handle delayed command execution. Decide when to execute the
 * command and when delay it, etc.
 *
 * @private
 * @param  {Process} proc
 * @param  {Command} cmd
 */


function doDelayExecCmd(proc, cmd$$1) {
  var tasks = proc.tasks;
  var taskId = cmd$$1.id;
  var tasksObj = tasks[taskId] = tasks[taskId] || {};
  var taskObj = tasksObj[DELAY_TASK];

  if (!taskObj) {
    var executor = function executor(finalCmd) {
      return doExecCmd(proc, finalCmd);
    };

    var cleanup = function cleanup() {
      return delete tasksObj[DELAY_TASK];
    };

    taskObj = tasksObj[DELAY_TASK] = new ThrottleTask(executor, cleanup, cmd$$1.options);
  }

  taskObj.exec(cmd$$1);
}
/**
 * The main class of MangoJuice that ties model, logic and view together.
 *
 * It works in the following way:
 * - You create a model for your app (object) using `createModel` of
 *   the root block. The result is a plain object.
 * - Then you need to create an instance of Process and pass logic class
 *   in the options object.
 * - Then you `bind` the Process instance to the model object you created on step one.
 *   "To bind Process to a model" means that in the model will be created a hidden
 *   field `__proc` with a reference to the Process instance.
 * - After that you can `run` the Process, which will execute init commands, port.
 *
 * `bind` and `run` also look at the object returned from {@link LogicBase#children}
 * and create/run Process instances for children models.
 *
 * Most of the time you do not need to care about all of these and just use
 * {@link run} and {@link mount}. These small functions do everything described
 * above for you.
 *
 * @class Process
 * @example
 * import { Process, logicOf } from 'mangojuice-core';
 *
 * const ExampleBlock = {
 *   createModel() {
 *     return { a: 10 };
 *   },
 *   Logic: class Example {
 *     \@cmd Increment(amount = 1) {
 *       return { a: this.model.a + amount };
 *     }
 *   }
 * };
 *
 * const model = ExampleBlock.createModel();
 * const proc = new Process({ logic: ExampleBlock.Logic });
 * proc.bind(model);
 * proc.run();
 * proc.exec(logicOf(model).Increment(23));
 */


function Process(opts) {
  var _this = this;

  var parent = opts.parent,
      sharedModel = opts.sharedModel,
      logger = opts.logger,
      logic = opts.logic,
      configArgs = opts.configArgs,
      context = opts.context;
  this.id = nextId();
  this.logicClass = logic;
  this.parent = parent;
  this.sharedModel = sharedModel;
  this.context = context || {};
  this.logger = logger || new DefaultLogger();
  this.configArgs = configArgs || EMPTY_ARRAY;
  this.computedFields = EMPTY_ARRAY;
  this.destroyPromise = new Promise(function (r) {
    return _this.destroyResolve = r;
  });
  this.tasks = {};
  this.observers = [];
  this.handlersAfter = [];
  this.handlersBefore = [];
  this.exec = this.exec.bind(this);
}

extend(Process.prototype,
/** @lends Process.prototype */
{
  /**
   * Bind the process instance to a given model, which means that hidden
   * `__proc` field will be created in the model with a reference to the
   * Process instance.
   *
   * Also bind all children models – go through children definition returned
   * by {@link LogicBase#children}, create Process for each child and bind
   * it to an appropreat child model object.
   *
   * @param  {Object} model  A model object that you want to bind to the Process.
   */
  bind: function bind(model) {
    prepareConfig(this);
    bindModel(this, model);
    bindChildren(this);
    bindComputed(this);
  },

  /**
   * Run the process – run children processes, then run port and
   * init commands defined in config.
   * Also run all model observers created by {@link observe}
   */
  run: function run() {
    runChildren(this);
    runPorts(this);
    runInitCommands(this);
    runAllObservers(this);
  },

  /**
   * Destroy the process with unbinding from the model and cleaning
   * up all the parts of the process (stop ports, computed fields).
   * `__proc` field will be removed from the model object and all
   * children objects.
   *
   * @param  {Boolean} deep   If true then all children blocks will be destroyed.
   *                          By default, if not provided then considered as true.
   */
  destroy: function destroy(deep) {
    delete this.model.__proc;
    this.observers = [];
    this.handlersBefore = [];
    this.handlersAfter = [];
    this.destroyed = true;
    stopPorts(this);
    stopComputedObservers(this);
    cancelAllTasks(this);

    if (deep !== false) {
      var childDestroyer = function childDestroyer(x) {
        return procOf(x).destroy(true);
      };

      forEachChildren(this, this.model, childDestroyer);
    }
  },

  /**
   * Exec a command in scope of the Process instance.
   * It will use binded model and logic object to run the
   * command. The command could be function (command factory)
   * or object ({@link Command} instance).
   *
   * A command origin function could return three types of things:
   * - Another {@link Command}/command factory or an array of commands
   *   (an element of the array also could be another array with commands
   *   or null/undefined/false). All commands will be execute in provided order.
   * - An instance of {@link TaskMeta} (which is usually created by {@link task}
   *   helper function). The returned task will be started and do not block
   *   execution of next commands in the stack.
   * - A plain object which is a model update object. The object will be merged
   *   with current model.
   *
   * If command is undefined or `Process` instance not binded
   * to any model it will do nothing.
   *
   * @example
   * class MyLogic {
   *   \@cmd BatchCommand() {
   *     return [
   *       1 > 2 && this.SomeCoomand,
   *       this.AnotheCommand(123),
   *       2 > 1 && [
   *         this.AndSomeOtherCommand,
   *         this.FinalCommand()
   *       ]
   *     ];
   *   }
   *   \@cmd TaskCommand() {
   *     return task(Tasks.SomeTask)
   *       .success(this.SuccessCommand)
   *       .fail(this.FailCommand)
   *   }
   *   \@cmd ModelUpdateCommand() {
   *     if (Math.random() > 0.6) {
   *       return { field: Date.now() };
   *     }
   *   }
   * }
   * @param  {Function|Object} cmd  Command factory or Command instance
   */
  exec: function exec(cmd$$1) {
    if (!cmd$$1 || this.destroyed) return; // Create result promise and get active model

    var realCmd = ensureCommand(cmd$$1);
    var cmdModel = realCmd.model || this.model;
    var modelProc = procOf(cmdModel, true); // Execute in current proc or in binded different proc

    if (modelProc) {
      if (modelProc.model !== this.model) {
        modelProc.exec(realCmd);
      } else {
        var opts = realCmd.options;

        if (opts.debounce > 0 || opts.throttle > 0) {
          doDelayExecCmd(this, realCmd);
        } else {
          doExecCmd(this, realCmd);
        }
      }
    }
  },

  /**
   * Returns a promise which will be resolved when all async
   * tasks and related handlers in the process and all children
   * processes will be finished.
   * @return {Promise}
   */
  finished: function finished() {
    var _this2 = this;

    var promises = [];

    for (var taskId in this.tasks) {
      for (var execId in this.tasks[taskId]) {
        var execution = this.tasks[taskId][execId].execution;

        if (is.promise(execution)) {
          promises.push(execution);
        }
      }
    }

    forEachChildren(this, this.model, function iterateChildren(childModel, fieldName) {
      var proc = procOf(childModel, true);

      if (proc) {
        var childFinished = proc.finished();

        if (childFinished !== EMPTY_FINISHED) {
          promises.push(childFinished);
        }
      }
    });
    return promises.length ? Promise.all(promises).then(function () {
      return _this2.finished();
    }) : EMPTY_FINISHED;
  }
});
/**
 * Basic class for every logic. It is not necessaty to inherit an actual logic
 * class from it, but for better type-checking it could be really usefull.
 *
 * Logic class defines:
 * - A set of commands that could change an associated model – methods decorated with {@link cmd}
 * - What fields of the model should be associated with which logic class
 *   (children blocks) – {@link LogicBase#children} method
 * - A set of computed model fields – {@link LogicBase#computed} method
 * - A set of rules to handle commands from children logic – {@link LogicBase#hubAfter}
 *   and {@link LogicBase#hubBefore} methods
 * - A logic to handle external events – {@link LogicBase#port} method.
 *
 * The logic class defines all the business-logic of some part of your application.
 * The main goal of the logic – change associated model. Check {@link cmd} and {@link Process#exec}
 * to have a better understanding how command can be defined and how it is executed.
 *
 * @class  LogicBase
 * @example
 * // ./blocks/MyBlock/Logic.js
 * // 
 * import type { Model } from './Model';
 * import ChildBlock from '../ChildBlock';
 * import { Command, cmd } from 'mangojuice-core';
 *
 * export default class MyLogic extends LogicBase<Model> {
 *   children() {
 *     return { child: ChildBlock.Logic };
 *   }
 *   hubAfter(cmd: Command) {
 *     if (cmd.is(ChildBlock.Logic.prototype.SomeCommand)) {
 *       return this.TestCommand(123);
 *     }
 *   }
 *   \@cmd TestCommand(arg) {
 *     return { field: arg + this.model.field };
 *   }
 * }
 * @property {Object} model   A model object which is associated with the
 *                            logic class in parent logic.
 * @property {Object} meta    An object defined in {@link LogicBase#config} method for storing
 *                            some internal logic state.
 * @property {Object} shared  An object with some shared state, defined while
 *                            run process of the app.
 */

function LogicBase() {}

extend(LogicBase.prototype,
/** @lends LogicBase.prototype */
{
  /**
   * A function that defines init commands and meta object of the
   * logic. Can accept any type and number of arguments. Config
   * will take arguments passed to {@link child} function (for example
   * `child(MyLogic, 1, 2, 3)` defines that the `config` method of
   * `MyLogic` will be invoked like `config(1, 2, 3)`)
   *
   * Could return an object with the fields:
   * - `initCommands` which could be an array or a single Command,
   *   that will be executed every time when the logic instance created
   *   and associated with some model (when {@link Process#run} invoked)
   * - `meta` which could be an object with some internal state of
   *   the logic
   *
   * @example
   * config(props) {
   *   return {
   *     initCommands: [ this.StartThis, this.SendThat(123) ],
   *     meta: { something: props.amount }
   *   };
   * }
   * @return {{ initCommands?: Command|Array<Command>, meta?: Object }}
   */
  config: function config() {},

  /**
   * This function defines what logic class should be associated
   * with which model field. Should return an object where a key is
   * a model field name, and a value is a logic class or an object
   * that defines logic with arguments (return from {@link child} function)
   *
   * @example
   * children() {
   *   return {
   *     searchForm: child(SearchForm.Logic, { timeout: 100 }),
   *     searchResults: SearchResults.Logic
   *   };
   * }
   * @return {Object}
   */
  children: function children() {},

  /**
   * Should return an object which defines computed fields of the model.
   * A key of the object is a model field, and value is a function or
   * computed function definition object (return from {@link depends} function).
   *
   * Computed field is lazy, which means that it is computed on the first use
   * of the field and the computation result cached until the next update
   * of the model.
   *
   * If you want to define a computed field which ueses in computation not
   * only fields from the own model, but maybe some values from child model,
   * or from shared model, then you will need to use {@link depends} function to
   * define what models used while computation to observe changes of these
   * models to trigger an update event of the own model (to update views).
   *
   * @example
   * computed() {
   *   return {
   *     simple: () => this.model.a + this.model.b,
   *     withDeps: depends(this.model.child, this.shared).compute(() => {
   *       return this.model.child.a + this.shared.b + this.model.c;
   *     })
   *   };
   * }
   * @return {Object}
   */
  computed: function computed() {},

  /**
   * A function to handle global event, such as browser-level events,
   * websocket, intervals. The main porpouse of the `port` is to subscribe
   * to some global events, execute appropriate commands from the logic
   * on the events and remove the handlers when the logic was destroyed.
   *
   * @example
   * port(exec, destroyed) {
   *   const timer = setInterval(() => {
   *     exec(this.SecondPassed);
   *   }, 1000);
   *   destroyed.then(() => clearInterval(timer));
   * }
   * @param  {Function} exec      It is a function that execute a passed command
   * @param  {Promise} destroyed  A promise that will be resolved when the logic destroyed
   */
  port: function port(exec, destroyed) {},

  /**
   * Hub for all commands executed in the children blocks. The only
   * arguments is a command object that was executed.
   * Could return a Command or an array of Commands that should
   * be executed next.
   * Most of the time this function will look like a `switch`,
   * but maybe with some additional rules for the cases. Take a look
   * to {@link Command#is} function to have a better understanding how you
   * can determine that the command is exactly what you are waiting for.
   *
   * @example
   * hubAfter(cmd) {
   *   if (cmd.is(ChildBlock.Logic.prototype.SomeCommand)) {
   *     return this.HandlerCommand(123);
   *   }
   *   if (cmd.is('AnotherChild.SomeAnothercommand')) {
   *     return [ this.HandlerCommand(321), this.AnotherHandler ];
   *   }
   * }
   * @param  {Command} cmd  Command that was executed in some child logic
   *                        or in any child of the child and so on down to
   *                        the leaf of the tree.
   * @return {?Command|?Array<Command>}
   */
  hubAfter: function hubAfter(cmd) {},

  /**
   * Same as {@link LogicBase#hubAfter}, but catch commands before
   * it will be actually executed, so you can compare prev and next
   * model state for example.
   *
   * @param  {Command} cmd
   * @return {?Command|?Array<Command>}
   */
  hubBefore: function hubBefore(cmd) {}
});
/**
 * Provides a way to define a command in the prototype without
 * usign a decorator. You should give a prototype of the logic class,
 * name of the function which should be converted to a command factory
 * and the decorator function (optional).
 *
 * If the decorator function is not provided, then {@link cmd} will be used
 * by default.
 *
 * @example
 * class MyLogic {
 *   SomeCommand() {
 *     return { field: this.model.field + 1 };
 *   }
 *   // throttle 100
 *   ThrottledCommand() {
 *     return this.SomeCommand();
 *   }
 * }
 *
 * defineCommand(MyLogic.prototype, 'SomeCommand');
 * defineCommand(MyLogic.prototype, 'ThrottledCommand', cmd({ throttle: 100 }));
 * @param  {Object}    proto  Logic class prototype
 * @param  {string}    name   Method name that you want to convert to a command factory
 * @param  {?function} decorator  Optional decorator function
 */

function defineCommand(proto, name, decorator) {
  var descr = Object.getOwnPropertyDescriptor(proto, name);
  var ensureDec = decorator || cmd;
  var newDescr = ensureDec(proto, name, descr);
  Object.defineProperty(proto, name, newDescr);
}
/**
 * Creates an object which describes child logic which will be attached
 * to some model field. Should be used in {@link LogicBase#children} to
 * define a logic that should be instantiated with some arguments passed
 * to {@link LogicBase#config}.
 *
 * @example
 * class ChildLogic {
 *   config(amount) {
 *     return { meta: { amount } };
 *   }
 * }
 * class RootLogic {
 *   children() {
 *     return {
 *       modelField: child(ChildLogic, 10)
 *       // `config` of `ChildLogic` will be invoked with
 *       // `10` as a first argument
 *     }
 *   }
 * }
 * @param  {LogicBase} logicClass  Class that imlements {@link LogicBase} interface
 * @return {Object} Object that contains a logic class and an arguments array that
 *                  should be used to invoke `config` method of provided logic class.
 */


function child(logicClass) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return {
    logic: logicClass,
    args: args
  };
}
/**
 * Class for declaring computed field with model dependencies.
 * Given array shuold contain models, binded to some
 * logec. They will be passed to compute function in the same order.
 * Also they will be used to track changed and re-compute.
 *
 * The class is immutable, so any call to any method will create
 * a new instance of `ComputedField` and the old one won't be touched.
 *
 * @class ComputedField
 * @property {Array<Object>} deps  An array of models with binded logic
 *                                 (attached some {@link Process})
 * @property {Function} computeFn  A compute function that will be used
 *                                 to compute value of the computed field.
 * @param {Array<Object>} deps
 */


function ComputedField(deps) {
  this.computeFn = noop;
  this.deps = deps;
}

extend(ComputedField.prototype,
/** @lends ComputedField.prototype */
{
  /**
   * Creates a new instance of the field and set compute function in it.
   *
   * @example
   * // A way to override computed field of some base logic class
   * // (thanks to immutability of `ComputedField`)
   * class MyLogic extends SomeOtherLogic {
   *   computed() {
   *     const oldComputed = super.computed();
   *     return {
   *       ...oldComputed,
   *
   *       // Override `oldField` compute function with saved dependencies
   *       // and use overrided compute function inside new compute function
   *       oldField: oldComputed.compute((...deps) => {
   *         return 1 > 0 || oldComputed.oldField.computeFn(...deps);
   *       })
   *     };
   *   }
   * }
   * @param  {Function} func  A compute function that should return a value that
   *                          will be used as a value for some computed field in
   *                          a model. This function will be invoked with all
   *                          dependency models as arguments
   * @return {ComputedField}  New instance of the ComputedField with `computeFn`
   *                          set to given function.
   */
  compute: function compute(func) {
    var nextDepends = new ComputedField(this.deps);
    nextDepends.computeFn = func;
    return nextDepends;
  }
});
/**
 * Function that helps to describe a computed field with external
 * model dependncies. Should be used in {@link LogicBase#computed}.
 * It creates an instance of {@link ComputedField} with dependencies
 * passed as arguments.
 *
 * A compute field with external dependencies is a field that should
 * be updated (re-computed) not only when the own model udpated, but
 * also when depdendency models updated.
 *
 * @example
 * class ChildLogic {
 *   // some logic
 * }
 * class MyLogic {
 *   children() {
 *     return { childModel: ChildLogic };
 *   }
 *   computed() {
 *     return {
 *       // depends on `childModel`
 *       computedField: depends(this.model.childModel).compute(() => {
 *         return this.model.a + this.model.childModel.b;
 *       }),
 *
 *       // depends on `shared` model
 *       computeWithShared: depends(this.shared).compute(() => {
 *         return this.model.b + this.shared.someField;
 *       })
 *     }
 *   }
 * }
 * @param  {...deps} deps  A list of models with attached logic
 * @return {ComputedField}
 */

function depends() {
  for (var _len = arguments.length, deps = Array(_len), _key = 0; _key < _len; _key++) {
    deps[_key] = arguments[_key];
  }

  return new ComputedField(deps);
}

function handleCmd(type, model, handler) {
  return observe(model, handler, {
    type: type
  });
}
/**
 * Function adds a handler to the {@link Process} attached to a given
 * model that will be invoked before every command running for this
 * model. The handler won't be invoked for commands from children
 * models of given model.
 *
 * Returns a function that removes the handler from the Process
 * (stop handling)
 *
 * @example
 * import { handleBefore, run, logicOf } from 'mangojuice-core';
 *
 * // Define root and child logic
 * class ChildLogic {
 *   \@cmd ChildCommand() {}
 * }
 * class MyLogic {
 *   children() {
 *     return { childModel: ChildLogic };
 *   }
 *   \@cmd RootCommand() {}
 * }
 *
 * // Run block with empty models
 * const res = run({
 *   Logic: MyLogic,
 *   createModel: () => ({ childModel: {} })
 * });
 *
 * // Adds a handler to a root model
 * handleBefore(res.model, (cmd) => console.log(cmd));
 *
 * // Run commands on root and child models
 * res.proc.exec(logicOf(res.model).RootCommand);
 * res.proc.exec(logicOf(res.model.childModel).ChildCommand);
 *
 * // In the console will be printed only `RootCommand` command object
 * // right before the command will be executed
 * @param  {Object} model       A model object with attached {@link Process}
 * @param  {Function} handler   A function that will be called before every own command
 * @return {Function} A function that stopps the handler
 */


var handleBefore = handleCmd.bind(null, 'handlersBefore');
/**
 * It is the same as {@link handleBefore} but the handler will be invoked
 * **after** every own command.
 *
 * @param  {Object} model       A model object with attached {@link Process}
 * @param  {Function} handler   A function that will be called after every own command
 * @return {Function} A function that stopps the handler
 */

var handleAfter = handleCmd.bind(null, 'handlersAfter');
/**
 * Alias for {@link handleAfter}
 *
 * @param  {Object} model       A model object with attached {@link Process}
 * @param  {Function} handler   A function that will be called after every own command
 * @return {Function} A function that stopps the handler
 */

var handle = handleAfter;
/**
 * Returns a Logic instance attached to a given model object. The logic
 * instance stored in attached {@link Process} instance, so it execute
 * {@link procOf} for the model to get a {@link Process} instance and then
 * get the logic instance form a Process and return it.
 *
 * If Process is not attached to the model, then an Error will be throwed.
 * If the second argument passed then it will also check that the logic
 * instance is instance of some particular class.
 *
 * @param  {Object} model        A model with attached {@link Process}
 * @param  {Class?} logicClass   Optional logic class to check that the logic
 *                               instance is instance of the class
 * @return {LogicBase} Returns a logic instance
 */

function logicOf(model, logicClass) {
  var proc = procOf(model);

  if (logicClass && !(proc.logic instanceof logicClass)) {
    throw new Error('Logic is not an instance of ' + logicClass.constructor.name);
  }

  return proc.logic;
} // Constants


var UPPERCASE_REGEX = /^_?[A-Z]/;
/**
 * By given logic class go through prototypes chain and
 * decorate all cmd functions. Use it if you can't use decorators
 * in your project
 *
 * It determine that the function should be converted to a command
 * factory (decorated by {@link cmd}) by its name. If the function
 * starts with uppercase letter or underscore+upper-letter, then it
 * is considered as a command.
 *
 * @example
 * class MyLogic {
 *   SomeCommand() {
 *   }
 *   _SomePrivateCommand() {
 *   }
 *   notACommand() {
 *     return 123;
 *   }
 * }
 *
 * // `SomeCommand` and `_SomePrivateCommand` will be decorated with `cmd`
 * // (the prorotype will be changed in-place). `notACommand` won't
 * // be decorated.
 * decorateLogic(MyLogic);
 *
 * const logic = new MyLogic();
 * logic.SomeCommand() // returns Command instance
 * logic._SomePrivateCommand() // returns Command instance
 * logic.notACommand() // returns 123
 * @param  {LogicBase} LogicClass   Logic class that you want to decorate
 * @param {bool} deep  If true then it will go though prototypes chain and
 *                     decorate every prototype in the chain.
 */

function decorateLogic(LogicClass, deep) {
  var proto = LogicClass.prototype || Object.getPrototypeOf(LogicClass);

  if (!proto || proto === Object.prototype) {
    return;
  } // Prepare next prototype in the chain


  if (deep) {
    decorateLogic(proto);
  } // Decorate all commands in the logic prototype


  maybeForEach(Object.getOwnPropertyNames(proto), function (k) {
    if (UPPERCASE_REGEX.test(k.charAt(0))) {
      var descr = Object.getOwnPropertyDescriptor(proto, k);

      if (!descr.get && descr.configurable) {
        Object.defineProperty(proto, k, cmd(proto, k, descr));
      }
    }
  });
  return LogicClass;
}
/**
 * Call some async function with arguments and returns
 * a Promise with `cancel` function. In context (in `this`)
 * of the function will be availble new function `call`,
 * that should be used to invoke other async functions.
 * It is needed to make possible to cancel the task at points
 * where `call` is used.
 *
 * If you will call `cancel` function execution of the
 * function will be stopped at point of some `call` execution.
 *
 * @private
 * @param  {Function}  fn
 * @return {Promise}
 */


function callTask(fn) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return new AsyncTask(this, fn, args);
}
/**
 * Creates a {@link TaskMeta} object that could be returned from
 * async task command. It describes the task that should be executed.
 *
 * For more information what the **Task** is and how it should be implemented
 * take a look to {@link TaskMeta}.
 *
 * @property {string} CANCEL  A symbol that you can use to make a promise "cancellable"
 * @param  {Function} taskFn  A function that could return a Promise
 * @return {Object}
 */


function task(taskFn) {
  return new TaskMeta(taskFn, callTask);
} // Export CANCEL symbol to be able to make cancellable promises


task.CANCEL = CANCEL;
/**
 * This function do the following:
 * - Creates a model object using {@link Block#createModel}. It is invoked without
 *   arguments.
 * - Create a {@link Process} instance with logic from {@link Block#Logic}
 * - Call {@link Process#bind} with created model
 *
 * Returns an object with created process instance, model object and given block.
 * Usefull when you want to prepare the block to run but you want to run it manually.
 *
 * @param  {Block} block   A {@link Block} object
 * @param  {?Object} opts  Options object that could change {@link Process} behaviour
 * @param  {?DefaultLogger} opts.logger   A custom logger instance that will be used in the
 *                                        Process to track commands execution. By default
 *                                        {@link DefaultLogger} will be used.
 * @param  {?Object} opts.shared     An object that will be available in any logic in the
 *                                   tree as `this.shared`. Could be anything you want, but
 *                                   you will get more benifites if you will pass model object
 *                                   with attached Process as shared object to be able to make
 *                                   computed fields with depending of shared model.
 * @param  {?Array<any>} opts.args        An array of arguments that will be passed to {@link LogicBase#config}
 *                                        of the logic.
 * @param  {?Process} opts.Process   A class that will be used instead of {@link Process}. By default
 *                                   general {@link Process} is used, but you can customize it for your
 *                                   specific needs and pass here. Then every other process in the tree
 *                                   will be an instance of this custom {@link Process} implementation
 * @return {{
 *   proc: Process,
 *   model: Object,
 *   block: Block
 * }} An object with {@link Process} instance, model object and block that was passed to
 *    the function
 */

function bind(block) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var ProcessClass = opts.Process || Process;
  var model = block.createModel();
  var proc = new ProcessClass({
    logic: block.Logic,
    logger: opts.logger,
    sharedModel: opts.shared || model,
    configArgs: opts.args || []
  });
  proc.bind(model);
  return {
    proc: proc,
    model: model,
    block: block
  };
}
/**
 * Run given block. It is a short-hand function for running {@link bind}
 * and then running a Process by {@link Process#run}.
 * Also it returns an additional `finished` Promise which is resolved
 * when all async tasks finished and all handler commands executed.
 *
 * @param  {Block} block  A block that you wan to run
 * @param  {Object} opts  Same options as in {@link bind}
 * @return {{ proc: Process, model: Object, block: Block, finished: Promise }}  An object
 *                  which is almost the same as returned from {@link bind}, but with
 *                  additional `finished` field, which is a Promise that will be resolved
 *                  when all blocks will execute all commands and all async tasks will be
 *                  finished.
 */


function run(block) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _bind = bind(block, opts),
      proc = _bind.proc,
      model = _bind.model;

  proc.run();
  return {
    proc: proc,
    model: model,
    block: block,
    finished: proc.finished()
  };
}
/**
 * To use {@link mount} function you need to implement a Mounter interface
 * which should have `mount` and `unmount` functions. It is up to the developer
 * how these functions will be implemented and what view library they will use.
 *
 * There is a rule that mounter and view library should follow: view of
 * a model should be updated only when the model updated and the update
 * shouldn't touch views of children models (children views shouldn't be updated
 * because their models is not changed).
 *
 * React perfectly fits for this rule. By implementing `shuoldComponentUpdate`
 * you can control when the component should be updated and when shouldn't. In this
 * case this function should always return `false` and componenent should be
 * updated using `forceUpdate` only when the model is updated (using {@link observe}).
 *
 * @example
 * // Minimal react mounter which follow the rules
 * class ViewWrapper extends React.Component {
 *   componentDidMount() {
 *     const { model } = this.props;
 *     this.stopObserver = observe(model, () => this.forceUpdate())
 *   }
 *   componentWillUnmount() {
 *     this.stopObserver();
 *   }
 *   shouldComponentUpdate() {
 *     return false;
 *   }
 *   render() {
 *     const { View, model } = this.props;
 *     const Logic = logicOf(model);
 *     return <View model={model} Logic={Logic} />
 *   }
 * }
 * class ReactMounter {
 *   mount(model, View) {
 *     return React.render(
 *       <ViewWrapper View={View} model={model} />,
 *       document.querySelector('#container')
 *     );
 *   }
 *   unmount() {
 *     return React.unmountComponentAtNode(
 *       document.querySelector('#container')
 *     );
 *   }
 * }
 * @interface Mounter
 * @property {Function} mount    A function that should expect two arguments: model object with
 *                               attached {@link Process} instance and {@link Block#View}.
 *                               It should render the model using given View (somehow).
 * @property {Function} unmount  A function that shuold unmount mounted view from DOM.
 */

/**
 * Mount running block. As third and next arguments you can pass other running
 * blocks which will be stopped with the main running block (useful for HMR).
 *
 * @example
 * const MyBlock = {
 *   createModel: () => ({ field: 1 }),
 *   Logic: class MyLogic {
 *     \@cmd SomeCommand() {
 *       return { field: this.model.field + 1 };
 *     }
 *   },
 *   View: ({ model }) => (
 *     <div>{model.field}</div>
 *   )
 * };
 *
 * mount(new ReactMounter(), run(MyBlock));
 * @param  {Mounter} mounter   An implementation of {@link Mounter} interface
 * @param  {{ proc: Process, block: Block, model: Object }} runRes  An object that returned
 *                  from {@link run} function.
 * @return {{ view: any, stop: Function }}  An object with the result form {@link Mounter#mount}
 *                  function (in `view` field) and stop function which destroy the process and
 *                  unmount a view using {@link Mounter#unmount}
 */


function mount(mounter, runRes) {
  for (var _len = arguments.length, otherBlocks = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    otherBlocks[_key - 2] = arguments[_key];
  }

  var view = mounter.mount(runRes.model, runRes.block.View);

  var stop = function stop() {
    runRes.proc.destroy();
    otherBlocks.forEach(function (x) {
      return x.proc.destroy();
    });
    mounter.unmount();
  };

  return {
    view: view,
    stop: stop
  };
}
/**
 * This function replace a `createModel` function in given block
 * with new function that just returns a given model. It is useful
 * when you have some old model and just want to run everytihing with
 * it (for example for server rendering, or hot module replacement)
 *
 * @example
 * // Hot module replacement example
 * import MyBlock from './MyBlock';
 * import { hydrate, run } from 'mangojuice-core';
 *
 * // Run initial block
 * let res = run(MyBlock);
 *
 * // When block changed destroy the old process, hydrate a new
 * // block with existing model and run hydrated new block again
 * module.hot.accept(['./MyBlock'], () => {
 *   res.proc.destroy();
 *   const newBlock = hydrate(require('./MyBlock'), res.model);
 *   res = run(newBlock);
 * });
 * @param  {Block} block   An original block
 * @param  {Object} model  A model object that you want to use
 * @return {Block}  A new block with replaced `createModel` function
 *                  which just returns a model that you passed as
 *                  second argument.
 */


function hydrate(block, model) {
  var newBlock = {};
  extend(newBlock, block);
  extend(newBlock, {
    createModel: function createModel() {
      return model;
    }
  });
  return newBlock;
}

exports.Process = Process;
exports.Command = Command;
exports.LogicBase = LogicBase;
exports.DefaultLogger = DefaultLogger;
exports.cmd = cmd;
exports.cancel = cancel;
exports.defineCommand = defineCommand;
exports.ensureCommand = ensureCommand;
exports.child = child;
exports.depends = depends;
exports.observe = observe;
exports.handle = handle;
exports.handleAfter = handleAfter;
exports.handleBefore = handleBefore;
exports.logicOf = logicOf;
exports.procOf = procOf;
exports.decorateLogic = decorateLogic;
exports.delay = delay;
exports.task = task;
exports.run = run;
exports.bind = bind;
exports.mount = mount;
exports.hydrate = hydrate;
exports.utils = utils;
exports.config = config;